// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import { DatePicker } from 'antd';
import { RangePickerDateProps } from 'antd/lib/date-picker/generatePicker';
import React, { ReactElement } from 'react';
import { Moment } from 'moment';
import { useGetSettings } from '@Queries/UISettingsQueries';

import './THRangePicker.scss';

interface THRangePickerProps extends RangePickerDateProps<Moment> {
    borderless?: boolean;
}

export const THRangePicker = ({ borderless = false, className, ...props }: THRangePickerProps): ReactElement => {
    const { data: settingsData } = useGetSettings();
    const { defaultDateFormat = '' } = settingsData || {};

    return (
        <DatePicker.RangePicker
            className={classList('th-range-picker', className, { 'no-border': borderless })}
            format={defaultDateFormat}
            dropdownClassName="th-range-picker__dropdown"
            {...props}
        />
    );
};
